import { MainNeetComponent } from './main-neet.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ChildComponentsModule } from '../components/child-components.module';
// import "@lottiefiles/lottie-player";
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ComponentsModule } from '../components/components.module';
// import { CourseComparisonIitComponent } from '../components/course-comparison-iit/course-comparison-iit.component'
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { CommonChildComponentsModule } from '../components/common-components.module'
import { CourseCardHomeComponent } from '../components/course-card-home/course-card-home.component';

export const routes:any[] = [
  {
    path: '', component: MainNeetComponent
  },
];


@NgModule({
  declarations: [
    MainNeetComponent,
    // CourseComparisonIitComponent
  ],
  imports: [
        CommonModule,
        RouterModule.forChild(routes),
        ReactiveFormsModule,
        ComponentsModule,
        SlickCarouselModule,
        ChildComponentsModule,
        CommonChildComponentsModule,
        MatChipsModule,
        MatButtonModule,
        CourseCardHomeComponent
  ],
  entryComponents: [
   
  ],
  
  providers: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class MainNeetModule { }
